module.exports = __webpack_public_path__ + "static/img/pinpad_error.6668b86.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/pinpad_error.png
// module id = 1Ggm
// module chunks = 1